export default {
  duplicate: {
    success: "This listing has been successfully copied to your drafts.",
  },
  search: {
    placeholder:
      "{isMobilePhone, plural, =1 {Search listings} other {Search by area, district, building name, address, ID, internal reference number or EAA required property number.}}",
    location: {
      level1: "Area",
      level2: "District",
      level3: "Building",
    },
    confirmText: "Search",
    searchBy: {
      text: "Search by area, district, building name, address, ID, internal reference number or EAA required property number.",
    },
  },
  listingList: {
    title: "Listings",
    propertyItem: {
      image: {
        alt: "Cover Image",
      },
      basicInfo: {
        price: "HK$ {price}",
        unit: "Unit {unit}",
        floor: "Floor {floor}",
      },
      buttons: {
        overview: "Overview",
        reporting: "Reporting",
        leads: "Leads",
        edit: "Edit",
        delete: "Delete",
        duplicate: "Copy",
        upgrade: "Upgrade",
        reactivate: "Reactivate",
        reactivating: "Reactivating...",
      },
      tierDate: {
        label: {
          empty: "No listing tier",
          suffix: "Listing",
        },
        exp: {
          normal: "Upgrade expiry: <strong>{value}</strong>",
          short: "Upgrade exp: <strong>{value}</strong>",
        },
        unit: "days",
        rotation: "Next rotation: <strong>{value}</strong>",
        today: "Today",
      },
      basicDate: {
        label: {
          "1": "Created ",
          "2": "Listed ",
          "3": "Offline ",
          "5": "Expired ",
        },
        id: "IPP ID: <strong>{value}</strong>",
        pgId: "PG ID: <strong>{value}</strong>",
        expires: {
          normal: "Listing expiry: <strong>{value}</strong>",
          short: "Listing exp: <strong>{value}</strong>",
        },
        unit: "days",
      },
      quality: "Quality listing",
      scheduled: "Scheduled",
      EAA: "EAA: <strong>{value}</strong>",
      discountedCredit: "Upgrade up to {percentage}% off",
    },
    message: {
      success: {
        upgrade: "This listing has been successfully upgraded.",
        reactivate: "Successfully made this listing online.",
        singleUpgrade: "Your listing has been upgraded.",
        singleOfflineAndExpired: "You have successfully made listing online.", // upgrade or reactivate
      },
    },
  },
  buttons: {
    addProperty: "Create a listing",
    bulkActions: {
      main: "More actions",
      offline: "Take offline",
      delete: "Delete",
      reactivate: "Reactivate",
      republish: "Reactivate",
      batch_upload: "Batch upload",
    },
    goToTop: "Return to the top",
  },
  promptMessage: {
    viewListings: "View listings",
  },
  bulkActions: {
    errorPopup: {
      title: "Your listings failed to make the updates.",
      subTitle:
        "Looks like some of your listings encountered some problem. Please try again.",
      cancel: "Dismiss",
    },
    label:
      "{selectedListingCount} listing{selectedListingCount, plural, =0 {} =1 {} other{s}} selected",
    note: "You can choose another <strong>{anotherCount}</strong> listing{anotherCount, plural, =0 {} =1 {} other{s}} (maximum of {maxCount})",
    maxNote: "You have reach the maximum selection",
    buttons: {
      cancel: "Cancel",
      selectAll: "Select all listings",
    },
    reactivate: {
      success:
        "You have successfully made {listingCount} listing{listingCount, plural, =0 {} =1 {} other{s}} online.",
      fail: "{errorCount} of your listings failed to make it online.",
      continueText: "Confirm",
    },
    republish: {
      success:
        "You have successfully made {listingCount} listing{listingCount, plural, =0 {} =1 {} other{s}} online.",
      fail: "{errorCount} of your listings failed to make it online.",
      continueText: "Confirm",
    },
    delete: {
      success:
        "You have successfully deleted {listingCount} listing{listingCount, plural, =0 {} =1 {} other{s}}.",
      fail: "{errorCount} of your listings failed to delete.",
      continueText: "Confirm",
    },
    offline: {
      success:
        "You have successfully made {listingCount} listing{listingCount, plural, =0 {} =1 {} other{s}} offline.",
      fail: "{errorCount} of your listings failed to make it offline.",
      continueText: "Confirm",
    },
    confirmationPopup: {
      cancel: "Cancel",
      reactivate: {
        confirm: "Reactivate now",
        title: "Are you sure you want to reactivate this listing(s)?",
        content:
          "Note: Your listing tier will remain the same, once online you can upgrade your listing to rank higher in the search results.",
      },
      republish: {
        confirm: "Reactivate now",
        title:
          "Are you sure you want to reactivate {count, plural, =1 {this listing} other {these listings}}?",
        content:
          "Please note, if you choose to reactivate {count, plural, =1 {this property it will be treated as a new listing} other {these properties they will be treated as new listings}}.",
      },
      delete: {
        confirm: "Yes, delete",
        title:
          "Are you sure you want to delete this {listingStatus, plural, =1 {draft} =3 {offline} =5 {expire} other {}} listing(s) permanently?",
        content:
          "You will not be able to undo this action if you choose to continue.",
      },
      offline: {
        confirm: "Yes, take offline",
        title: "Are you sure you want to take this listing(s) offline?",
        content:
          "Note: The time your listing spends offline will not be reimbursed. Days remaining for an upgrade or standard listing will continue to be consumed.",
      },
      selectAll: {
        confirm: "Yes, proceed",
        title: "You are trying to select more than 50 listings",
        content:
          "If you select all the listings on this page, your previous selections will be removed. Are you sure you want to proceed?",
      },
    },
    progress: {
      complete: "Completed!",
      inProgress: "In Progress",
    },
    title: {
      offline: "Select listings to take offline",
      delete: "Select listings to delete",
      reactivate: "Select listings to reactivate",
      republish: "Select listings to reactivate",
    },
    selected: "<strong>{count}</strong> selected",
  },
  listingError: {
    heading: "We couldn't find any properties that match your refinements.",
    subHeading:
      "Try changing your criteria to find the property you are after.",
  },
  filters: {
    label: "{count} Filters",
    select: {
      default: "All",
    },
    moreFilters: {
      label: "More",
    },
    count: "Show {count} properties",
    channels: {
      title: "Listing type",
      auction: "Auction",
    },
    propertyType: {
      title: "Property type",
    },
    agency: {
      title: "Agency",
      placeholder: "Agency",
      mobilePlaceholder: "All",
    },
    tier: {
      title: "Upgrade",
      degraded: "Degraded",
    },
    branch: {
      title: "Branch",
      placeholder: "Branch",
      mobilePlaceholder: "All",
    },
    agent: {
      title: "Search listings by",
      placeholder: "Agent name",
      mobilePlaceholder: "Agent name",
    },
    sort: {
      title: "Sort by",
      "new-to-old":
        "{listingStatus, plural, =1 {Created} =2 {Listed} =3 {Offline} =5 {Expired} other {}} (New to old)",
      "old-to-new":
        "{listingStatus, plural, =1 {Created} =2 {Listed} =3 {Offline} =5 {Expired} other {}} (Old to new)",
      "old-to-new-expiry-date": "Listing expiry date",
      "product-expiry-date": "Upgrade expiry date",
      "high-to-low": "Price (High to low)",
      "low-to-high": "Price (Low to high)",
    },
    quality: {
      title: "Quality",
      true: "Quality completed",
      false: "Quality incomplete",
    },
    agentType: {
      title: "Agent Type",
      primary: "Primary Agent",
      secondary: "Secondary Agent",
    },
    category: {
      title: "Category",
    },
    unitType: {
      title: "Unit type",
    },
    priceRange: {
      title: "Price range ({unit})",
      shortTitle: "Price range",
      form: {
        placeholder: "Min price",
      },
      to: {
        placeholder: "Max price",
      },
    },
    autoUpgrade: {
      title: "Auto-upgrade",
      default: "All",
      on: "On",
      off: "Off",
    },
    clear: {
      short: "Clear",
      full: "Clear filters",
    },
    filter: {
      button: "Filter",
    },
  },
  batchUpload: {
    back: "Back to listings",
    upload: {
      title: "Upload multiple listings at once",
      message:
        "Please supply files that are CSV format and a maximum file size of 4MB.",
      button: "Upload your file",
    },
    detail: {
      title: "Upload details",
      uploading: "Upload in progress",
      success: "File successfully uploaded",
      message:
        "Your listings are being created. You will receive an email once your listing are online, which will include a report of your batch upload.",
    },
    guide: {
      title: "Uploading guides",
      message:
        "View our guidelines on how to supply your CSV file by clicking on the link below.",
      pdf: "View upload guide",
    },
    assets: {
      title: "Batch upload assets",
      message:
        "Use the following templates and information to help load your properties.",
      csv: "CSV template",
      xml: "XML template",
      building: "Building database",
      reference: "Reference list",
    },
    errors: {
      size: "file size can not be larger than 4MB.",
      upload:
        "There was an error whilst trying to upload your file. Please try uploading it again.",
    },
  },
};
